import moment from 'moment';
import 'moment/locale/de';
import 'moment/locale/es';
import 'moment/locale/fr';
import 'moment/locale/it';
import 'moment/locale/ja';
import 'moment/locale/nl';
import 'moment/locale/pt';
import 'moment/locale/ru';

import LocaleExtends from './extensions/LocaleExtends';

const defaultLongDateFormatKey = 'll';
const defaultFormat = 'MMM D, YYYY';

class UX1DatePrivate extends LocaleExtends {
	public moment: typeof moment = moment;

	private format: string = defaultFormat;
	private longDateFormatKey: moment.LongDateFormatKey = defaultLongDateFormatKey;

	private setLongDateFormatKey(longDateFormatKey: moment.LongDateFormatKey): void {
		this.longDateFormatKey = longDateFormatKey;
	}

	public getLongDateFormatKey(): moment.LongDateFormatKey {
		return this.longDateFormatKey;
	}

	private getLongDateFormat(longDateFormatKey = this.longDateFormatKey): string {
		const localeData = this.moment.localeData();

		return localeData.longDateFormat(longDateFormatKey);
	}

	private setFormat(frmt: string): void {
		this.format = frmt;
	}

	private setFormatWithLongFormat(): void {
		this.setFormat(this.getLongDateFormat());
	}

	public getFormat(): string {
		return this.format;
	}

	public getDate(dt: string, frmt?: string): string {
		const { format } = this;

		return this.moment.utc(dt).format(frmt || format);
	}

	public getDateWithLongFormat(dt: string, longDateFormatKey: moment.LongDateFormatKey): string {
		const longFormat = this.getLongDateFormat(longDateFormatKey);

		return this.getDate(dt, longFormat);
	}

	public setCurrentLocale(
		locale: string,
		longDateFormatKey: moment.LongDateFormatKey = defaultLongDateFormatKey
	): void {
		this.moment.locale(locale);
		this.setLocale(locale);
		this.setLongDateFormatKey(longDateFormatKey);
		this.setFormatWithLongFormat();
	}
}

export const ux1DatePrivate = new UX1DatePrivate();

class UX1Date {
	/**
	 * Full object MomentJS
	 */
	public moment: typeof moment = ux1DatePrivate.moment;

	/**
	 * Get current locale
	 */
	public getLocale(): string {
		return ux1DatePrivate.getLocale();
	}

	/**
	 * Get current LongDateFormatKey
	 * @link: https://momentjscom.readthedocs.io/en/latest/moment/07-customization/06-long-date-formats/
	 */
	public getLongDateFormatKey(): moment.LongDateFormatKey {
		return ux1DatePrivate.getLongDateFormatKey();
	}

	/**
	 * Get current DateFormat by current longDateFormatKey
	 */
	public getFormat(): string {
		return ux1DatePrivate.getFormat();
	}

	/**
	 * Get date with current DateFormat (by default or use other)
	 */
	public getDate(dt: string, frmt?: string): string {
		return ux1DatePrivate.getDate(dt, frmt);
	}

	/**
	 * Get date with LongDateFormatKey
	 */
	public getDateWithLongFormat(dt: string, longDateFormatKey: moment.LongDateFormatKey): string {
		return ux1DatePrivate.getDateWithLongFormat(dt, longDateFormatKey);
	}
}

const ux1Date = new UX1Date();

export default ux1Date;
